import React, { useState, useEffect } from 'react';
import ConfiguracionView from './ConfiguracionView';
import { BE_URL, httpGet, httpPut, httpPost } from '../../../http';
import './Configuracion.css';
import { config } from '@fortawesome/fontawesome-svg-core';

const Configuracion = (props) => {

    const [ configuracion, setConfiguracion ] = useState({
        id: null,
        logo: '',
        siteName: '',
        diaExpedicion: ''
    });

    const [ request, setRequest ] = useState({
        lading: true,
        error: false,
        errorMsg: ''
    });

    const [ reqConfiguracion, setReqConfiguracion ] = useState({
        lading: false,
        success: false,
        error: false,
        errorMsg: ''
    });
    
    useEffect(() => {
        getConfiguracion();
    }, []);

    const getConfiguracion = async () => {
        setRequest({
            ...request,
            loading: true,
            error: false,
            errorMsg: ''
        });
        const reqConfiguracion = await httpGet(BE_URL + '/ProveedoresWS/api/Configuration');
        if(reqConfiguracion.data){
            setConfiguracion(reqConfiguracion.data);
        }
        setRequest({
            ...request,
            loading: false,
            error: false,
            errorMsg: ''
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log(e);

        setReqConfiguracion({
            ...reqConfiguracion,
            loading: true,
            success: false,
            error: false,
            errorMsg: ''
        });

        if(configuracion.siteName.length < 1){
            setReqConfiguracion({
                ...reqConfiguracion,
                loading: false,
                success: false,
                error: true,
                errorMsg: 'Debe ingresar un nombre para el sitio'
            });
            console.log("error 1");
            return 0;
        }

        if(configuracion.diaExpedicion.length < 1){
            setReqConfiguracion({
                ...reqConfiguracion,
                loading: false,
                success: false,
                error: true,
                errorMsg: 'Debe ingresar un dia de expedición'
            });
            console.log("error 2");
            return 0;
        }

        try{
            const data = {
                id: configuracion.id,
                logo: configuracion.logo,
                siteName: configuracion.siteName,
                diaExpedicion: parseInt(configuracion.diaExpedicion)
            }
            console.log(configuracion);
            const reqConfiguracion = await httpPost(BE_URL + '/ProveedoresWS/api/Configuration', data);
            if(reqConfiguracion.data){
                setConfiguracion(configuracion);
                setReqConfiguracion({
                    ...reqConfiguracion,
                    loading: false,
                    success: true,
                    error: false,
                    errorMsg: ''
                });
                console.log("success");
            }
        } catch(error) {
            console.log(error);
            console.log("error 3");
            setReqConfiguracion({
                ...reqConfiguracion,
                loading: false,
                success: false,
                error: true,
                errorMsg: 'Ocurrio un error al guardar la configuración'
            });
        }

    }

    const handleChange = (e) => {
        setConfiguracion({
            ...configuracion,
            [e.target.name]: e.target.value
        });
    }

    return <ConfiguracionView configuracion={configuracion} onSubmit={handleSubmit} onChange={handleChange} request={request} reqConfiguracion={reqConfiguracion} />;
}

export default Configuracion;